import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast, ToastModule } from "primeng/toast";
import { GlobalSettingsService } from './shared/services/global-settings.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule, HttpClientModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('franklins-frontend');
  private _settings = inject(GlobalSettingsService);
}

